import * as React from 'react';
import {StyleSheet, Text, TextStyle, View, ViewStyle} from 'react-native';

import QuestionList from '../../questions/components/QuestionList';
import DefaultOutlineButton from '../../../shared/buttons/DefaultOutlineButton';

import Question from '../../../../../domain/entities/writer/faq/Question';

interface Props {
  title: string;
  questions: Array<Question> | null;
  onPressMore?: () => void;
}

const QuestionListSection: React.FC<Props> = props => {
  const {title, questions, onPressMore} = props;
  if (!questions || questions.length === 0) {
    return null;
  }
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <QuestionList questions={questions} />
      {onPressMore ? (
        <DefaultOutlineButton style={styles.button} onPress={onPressMore}>
          もっと見る
        </DefaultOutlineButton>
      ) : null}
    </View>
  );
};

export default React.memo(QuestionListSection);

const styles = StyleSheet.create({
  container: {
    marginVertical: 24,
  } as ViewStyle,
  title: {
    color: '#383838',
    fontSize: 15,
    fontWeight: 'bold',
    margin: 16,
  } as TextStyle,
  button: {
    alignSelf: 'center',
    width: 240,
    height: 46,
    marginTop: 24,
  } as ViewStyle,
});
